module.exports = __webpack_public_path__ + "img/gift.a7e7358b.png";